<template>
  <div class="index" :class="pageGray ? 'gray-scale' : ''">
    <template v-if="firstLoading">
      <div class="skeleton_banner"></div>
      <div class="w_sld_react_1210 adv_04_wrap skeleton">
        <div class="floor_title">
          <h2>
            <font>&nbsp;</font>
            <span></span>
            <font>&nbsp;</font>
          </h2>
        </div>
        <!-- <div class="floor_goods">
          <div
            class="item"
            v-for="(item_main, index_main) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
            v-bind:key="index_main"
          >
            <div class="wrap">
              <a href="javascript:void(0)" class="example_text"> </a>
              <p class="title">
                <a href="javascript:void(0)">{{ item_main }}</a>
              </p>
              <p class="price"><span></span></p>
            </div>
          </div>
        </div> -->
      </div>
    </template>
    <SldDiy
      v-if="decorateData.data.length"
      :decorateData="decorateData"
      :isTopic="true"
       :background="pageColor"
    />
    <!-- 空页面 start-->
    <SldCommonEmpty
      v-if="!firstLoading && !decorateData.data.length"
      totalHeight="900"
      paddingTop="250"
      tip="'我们正在努力装修中，敬请期待～'"
    />
    <!-- 空页面 end-->
  </div>
</template>
<script>
import { reactive, getCurrentInstance, ref } from 'vue'
import SldDiy from '../../components/SldDiy'
import { useRoute } from 'vue-router'
import SldCommonEmpty from '../../components/SldCommonEmpty'
import { ElMessage} from 'element-plus'
export default {
  name: 'Topic',
  components: {
    SldDiy,
    SldCommonEmpty
  },
  setup() {
    const route = useRoute()
    const adv_21_right_icon = require('../../assets/decorate/right_more_icon.png')
    const adv_24_let_default_pic = require('../../assets/decorate/adv_24_let_default_pic.png')
    const decorateData = reactive({ data: [] }) //装修数据
    const firstLoading = ref(true) //是否第一次加载
    const pageColor = ref('')
    const { proxy } = getCurrentInstance();
    const pageGray = ref(false);
    const getInitData = () => {
      let param = {};
      param.decoId = route.query.topicId;
      let draft = route.query.draft;
      let preview = route.query.type == 'view';

      let url = preview ? 'v3/system/front/pcDeco/display' : 'v3/system/front/pcDeco/index';
      proxy.$get(url, param).then((res) => {
      
        firstLoading.value = false;
        if (res.state == 200) {
          if (draft == 1) {
            decorateData.data = JSON.parse(
              res.data.draft.replace(/&quot;/g, '"')
            );
          } else {
            decorateData.data = JSON.parse(
              res.data.data.replace(/&quot;/g, '"')
            );
          }
          console.log("getInitData decorateData===",decorateData)
          decorateData.data.map((item) => {
            item.json_data = item.json;

            if (item.tplPcId == 0 || item.json_data && item.json_data.type == "main_banner") {
              pageGray.value = item.page_gray;
              pageColor.value = item.page_color;
            }

            if (item.json_data && item.json_data.type == "adv_19") {
              item.json_data.data.map((child) => {
                child.cur_tab = 0;
              });
            }
            if (item.json_data && item.json_data.type == "oneEight") {
              let ids = [];
              item.json_data.imgArr.forEach((i) => {
                ids.push(i.productId);
              });
              getProductData(ids, item.json_data.id);
            } else if (item.json_data && item.json_data.type == "twoEight") {
              let twoIds = [];
              item.json_data.imgArr.forEach((i) => {
                twoIds.push(i.productId);
              });
              getProductData(twoIds, item.json_data.id);
            } else if (item.json_data && item.json_data.type == "zeroFive") {
              let zeroIds = [];
              item.json_data.imgArr.forEach((i) => {
                zeroIds.push(i.productId);
              });
              getProductData(zeroIds, item.json_data.id);
            }
          });

          // liftData.value = decorateData.data.filter(
          //   (i) => i.json_data.type == "text_title"
          // );
          // let couponData = decorateData.data.filter(
          //   (i) => i.json_data.type == "coupon_fixed" && i.json_data.state != 4
          // );
          // if (couponData.length != 0) {
          //   getCouponList(couponData[0].json_data);
          // } else {
          //   showCoupon.value = false;
          // }
          console.log(11, decorateData.data);
          // let data = decorateData.data.filter(
          //   (i) => i.json_data.type == "text_title"
          // );
          // proxy.$emit("childData", data);
        } else{
          console.log("getInitData ElMessage.error===",ElMessage.error)
          ElMessage.error(res.msg)
        }
      });
    };
    const getProductData = async (arr, id) => {
      let config = {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
      };
      let param = {
        productIds: arr,
      };
      proxy
        .$post("v3/goods/front/goods/productList", param, config)
        .then((res) => {
          if (res.state == 200) {
            if(res.data.list){
              res.data.list.forEach((i) => {
                i.fresh = true;
              });
            }
            decorateData.data.map((item) => {
              if (item.json_data.id == id) {
                // item.json_data.info = res.data.list;
                let mergedArray = item.json_data.imgArr.map((item1) => {
                  let item2 = res.data.list.find(
                    (items) => items.productId == item1.productId
                  );
                  return {
                    ...item1,
                    ...item2,
                  };
                });
                console.log("imgArr========", mergedArray);
                item.json_data.info = mergedArray;
                item.json_data.info.forEach(value =>{
                  value.newProdcut = false;
										if (value.activityList && value.activityList.length != 0) {
											value.activityList.forEach((aItem) => {
												if (aItem.promotionType == 403) { //赠品
                          aItem.promotionName='赠品';
												} else if (aItem.promotionType == 405) {
													// mxList=mxList.concat(aItem.descriptionList)

												} else if (aItem.promotionType == 402) {
													// yhqlist=yhqlist.concat(aItem.descriptionList)

												} else if (aItem.promotionType == 103) {
													// item.hasAct=1;
													// item.promotionType=aItem.promotionType;
													// item.showName='预售';
                          aItem.promotionName='预售';
												} else if (aItem.promotionType == 106) {
													// item.hasAct=1;
													// item.promotionType=aItem.promotionType;
													// item.showName='抢购';
                          aItem.promotionName='限时';
												} else if (aItem.promotionType == 107) {
													// item.hasAct=1;
													// item.promotionType=aItem.promotionType;	
													// item.showName='预约';	
                          aItem.promotionName='预约';
												} else if (aItem.promotionType == 501) {
													// item.hasAct=1;
													// item.firstOrder=1; 
													// item.promotionType=aItem.promotionType;	
													// item.showFirstName='首单';	
                          aItem.promotionName='专享';
												} else if (aItem.promotionType == 408) { //新品  									
													value.newProdcut = true;
													// item.promotionType=aItem.promotionType;
												} else if (aItem.promotionType == 406) {
                          aItem.promotionName='';
												} 
											})

											// tmpList=zplist.concat(mxList)
											// tmpList=tmpList.concat(yhqlist)								
											// item.actShowList=tmpList;	
										}
                })
              }
            });
          }
        });
    };
    const getCouponList = async (data) => {
      let ids = [];
      data.data.forEach((i) => {
        ids.push(i.couponId);
      });
      let param = {
        couponIds: ids,
      };
      let config = {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
      };
      proxy
        .$post("/v3/promotion/front/coupon/diyHomeCouponList", param, config)
        .then((res) => {
          if (res.state == 200) {
            console.log(res);
            couponData.value = res.data;
            showCoupon.value = true;
          }
        });
    };
    getInitData()
    return {
      adv_21_right_icon,
      adv_24_let_default_pic,
      decorateData,
      firstLoading,
      pageColor,
      pageGray
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/decorate.scss';

.index {
  background: #f8f8f8;
  padding-bottom: 10px;
}

.skeleton_banner {
  width: 100%;
  height: 470px;
  background: $colorSkeleton;
  margin-bottom: 10px;
}

.skeleton {
  &.adv_04_wrap .floor_title h2 span {
    background: $colorSkeleton;
    display: inline-block;
    width: 200px;
  }

  &.adv_04_wrap .floor_goods .item .wrap .title {
    background: $colorSkeleton;
    width: 100%;

    a {
      color: transparent;
    }
  }

  &.adv_04_wrap .floor_goods .item .wrap .price {
    width: 100%;
    height: 25px;
  }

  &.adv_04_wrap .floor_goods .item .wrap .price span {
    display: inline-block;
    width: 70px;
    height: 100%;
    background: $colorSkeleton;
  }
}

.gray-scale {
    filter: grayscale(100%); /* 置灰效果 */
  }
</style>
